import React, { useEffect, useState, useRef } from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import IconButton from "@material-ui/core/IconButton";
import Close from "@material-ui/icons/Close";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Help from "@material-ui/icons/HelpOutline";
import "./Navbar.css";
import { withRouter } from "react-router-dom";
import { InjectedConnector } from "@web3-react/injected-connector";

import VersionSwitch from "../versionSwitch/versionSwitch";

import {
  Grid,
  Link,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Button,
  Hidden,
  withWidth,
  SwipeableDrawer,
  Tooltip,
  Backdrop,
} from "@material-ui/core";
import UserPortfolio from "../../Common/UserPortfolio/UserPortfolio";
import BuyPHNX from "../../Common/BuyPHNX/BuyPHNX";

import LogoDarkClose from "../../../Assets/menu/logoDarkClose.svg";
import LogoLightClose from "../../../Assets/menu/logoLightClose.svg";

import SidebarLogoOpen from "../../../Assets/side bar phoneix logo.svg";

import DashboardLight from "../../../Assets/drawer/try/dashboardLight.svg";
import DashboardLightActive from "../../../Assets/drawer/try/dashboardLightActive.svg";
import StakeLight from "../../../Assets/drawer/try/stakeLight.svg";
import StakeLightActive from "../../../Assets/drawer/try/stakeLightActive.svg";
import UnstakeLight from "../../../Assets/drawer/try/unstakeLight.svg";
import UnstakeLightActive from "../../../Assets/drawer/try/unstakeLightActive.svg";

import DashboardDark from "../../../Assets/drawer/try/dashboardDark.svg";
import DashboardDarkActive from "../../../Assets/drawer/try/dashboardDarkActive.svg";
import StakeDark from "../../../Assets/drawer/try/stakeDark.svg";
import StakeDarkActive from "../../../Assets/drawer/try/stakeDarkActive.svg";
import UnstakeDark from "../../../Assets/drawer/try/unstakeDark.svg";
import UnstakeDarkActive from "../../../Assets/drawer/try/unstakeDarkActive.svg";

import MenuIconClose from "../../../Assets/menu/menuHamburger.svg";
import MenuIconOpen from "../../../Assets/menu/menuHamburgerClose.svg";

import ConnectwalletIcon from "../../../Assets/Connect plus.svg";
import MetamaskIcon from "../../../Assets/metamask 1.svg";

import TwitterLight from "../../../Assets/social/twitterLight.svg";
import TelegramLight from "../../../Assets/social/telegramLight.svg";
import GithubLight from "../../../Assets/social/githubLight.svg";
import LinkedinLight from "../../../Assets/social/linkedinLight.svg";
import TwitterDark from "../../../Assets/social/twitterDark.svg";
import TelegramDark from "../../../Assets/social/telegramDark.svg";
import GithubDark from "../../../Assets/social/githubDark.svg";
import LinkedinDark from "../../../Assets/social/linkedinDark.svg";

import SunLight from "../../../Assets/switch/SunLight.svg";
import MoonLight from "../../../Assets/switch/MoonLight.svg";
import SunDark from "../../../Assets/switch/SunDark.svg";
import MoonDark from "../../../Assets/switch/MoonDark.svg";

import {
  checkWeb3,
  web3React,
  checkWeb3React,
} from "../../../store/actions/layoutActions";
import { connect } from "react-redux";

import { themeModeChanged } from "../../../store/actions/layoutActions";
import { sideDrawerClicked } from "../../../store/actions/layoutActions";

import { useWeb3React } from "@web3-react/core";
import { useEagerConnect, useInactiveListener } from "../Web3React/hooks";
import { injected } from "../Web3React/connectors";

import { useMediaQuery } from "../../../CustomHooks/index";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),

    "@media (min-width: 2400px)": {
      marginLeft: "480px",
      width: `calc(100% - 480px)`,
    },
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },

  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",

    "@media (min-width: 2400px)": {
      width: "480px",
    },
  },
  drawerOpen: {
    background: theme.palette.secondary.main,
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),

    "@media (min-width: 2400px)": {
      width: "480px",
    },
  },
  drawerClose: {
    background: theme.palette.secondary.main,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",

    width: theme.spacing(7) + 1,

    "@media (min-width: 2400px)": {
      width: "120px",
    },
  },

  navItem: {
    padding: "8px 12px",
    marginTop: "32px",
    color: "white",
  },

  navItemActiveLight: {
    padding: "8px 12px",
    marginTop: "32px",
    color: "white",
    borderLeft: "2px solid #FFFFFF",
    background:
      "linear-gradient(-270deg, rgba(255, 255, 255, 0.14) -5.93%, rgba(255, 255, 255, 0) 100%)",
  },
  navItemActiveDark: {
    padding: "8px 12px",
    marginTop: "32px",
    color: "white",
    borderLeft: "2px solid #EA8604",
    background:
      "linear-gradient(-270deg, rgba(234, 134, 4, 0.35) -5.93%, rgba(255, 180, 83, 0) 100%);",
  },
  connectButton: {
    display: "flex",
    padding: "4px 12px",
    background: "#EA8604",
    borderRadius: "31.5px",
    fontSize: "14px",
    "&:hover": {
      cursor: "pointer",
    },
    "@media (min-width: 2400px)": {
      fontSize: "30px",
    },
  },

  connectButtonIcon: {
    height: "30px",
    width: "100%",
    "@media (min-width: 2400px)": {
      height: "45px",
    },
  },

  plusButton: {
    "&:hover": {
      cursor: "pointer",
    },
    "@media (min-width: 2400px)": {
      fontSize: "32px",
    },
  },

  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  contentBack: {
    flexGrow: 1,
    backgroundColor: theme.palette.secondary.main,
    margin: 0,
    padding: 0,
    // padding: theme.spacing(3),
  },

  content: {
    backgroundColor: theme.palette.primary.main,
    borderTopLeftRadius: "20px",
    borderBottomLeftRadius: "20px",
    margin: 0,
    minHeight: "100vh",
    paddingTop: "16px",
    [theme.breakpoints.down("sm")]: {
      borderTopLeftRadius: "0px",
      borderBottomLeftRadius: "0px",
    },
  },

  mySwitch: {
    padding: "4px 6px",

    borderRadius: "17px",
  },

  logoStyles: {
    height: "48px",

    "@media (min-width: 2400px)": {
      height: "96px",
    },
  },

  navImage: {
    height: 35,
    width: 25,

    "@media (min-width: 2400px)": {
      height: "70px",
      width: "50px",
      margin: "10px",
      marginRight: "60px",
    },
  },

  navText: {
    fontSize: "16px",
    "@media (min-width: 2400px)": {
      fontSize: "32px",
    },
  },

  menuIconOpen: {
    height: 24,

    "@media (min-width: 2400px)": {
      height: "48px",
    },
  },
  menuIconClose: {
    height: 40,

    "@media (min-width: 2400px)": {
      height: "80px",
    },
  },

  hoverTackle: {
    "&:hover": {
      boxShadow: "none !important",
    },
  },

  myPara: {
    fontSize: 16,
    "@media (min-width: 2400px)": {
      fontSize: 24,
    },
  },

  socialIcons: {
    height: 24,
    "@media (min-width: 2400px)": {
      height: 36,
    },
  },

  help: {
    color: "#EA8604",
    marginLeft: "12px",
    cursor: "pointer",
    "@media (min-width: 2400px)": {
      fontSize: 48,
    },
  },

  plusImage: {
    height: 32,
    "@media (min-width: 2400px)": {
      height: 64,
    },
  },

  walletText: {
    fontSize: 14,
    "@media (min-width: 2400px)": {
      fontSize: 30,
    },
  },
}));

let ConnectorNames = {
  Injected: "Injected",
};

const connectorsByName = {
  [ConnectorNames.Injected]: injected,
};

const MiniDrawer = (props) => {
  const context = useWeb3React();
  const {
    connector,
    library,
    chainId,
    account,
    activate,
    deactivate,
    active,
    error,
  } = context;

  // handle logic to recognize the connector currently being activated
  const [activatingConnector, setActivatingConnector] = React.useState();
  React.useEffect(() => {
    if (activatingConnector && activatingConnector === connector) {
      setActivatingConnector(undefined);
    }
  }, [activatingConnector, connector]);

  // handle logic to eagerly connect to the injected ethereum provider, if it exists and has granted access already
  const triedEager = useEagerConnect();

  // handle logic to connect in reaction to certain events on the injected ethereum provider, if it exists
  useInactiveListener(!triedEager || !!activatingConnector);

  useEffect(() => {
    props.themeModeChanged(localStorage.getItem("themeMode"));
    window.addEventListener("resize", handleResize);
  }, [props]);

  useEffect(() => {
    let status = localStorage.getItem("checkWeb3ReactStatus") || "true";
    // alert(status);
    if (status == "true" && account != undefined) {
      // alert("ruuning checkWeb3React");
      props.checkWeb3React({ address: account, network: chainId });
      localStorage.setItem("checkWeb3ReactStatus", "false");
      setTimeout(() => {
        localStorage.setItem("checkWeb3ReactStatus", "true");
      }, 500);
    }
  }, [account, chainId, props]);

  const classes = useStyles();
  const theme = useTheme();
  let refresh = useRef(false);

  const [open, setOpen] = React.useState(false);
  const [connect, setConnect] = React.useState(false);
  const [numioWallet, setnumioWallet] = React.useState(false);
  const [mobileDrawer, setMobileDrawer] = React.useState(false);
  const [connectDropdowm, setConnectDropdown] = React.useState(false);
  const [themeMode, setThemeMode] = useState(localStorage.getItem("themeMode"));
  const [windowWidth, setWindowWidth] = useState();
  const [MMAccount, setMMAccount] = useState("");

  const refreshCheck = localStorage.getItem("themeMode");
  if (refreshCheck) {
    // console.log("themeMode already set");
  } else {
    localStorage.setItem("themeMode", "light");
    setThemeMode("light");
  }

  const toggleThemeMode = () => {
    if (themeMode === "dark") {
      localStorage.setItem("themeMode", "light");
    } else {
      localStorage.setItem("themeMode", "dark");
    }
    setThemeMode(localStorage.getItem("themeMode"));
    props.themeModeChanged(localStorage.getItem("themeMode"));
  };

  const handleResize = (e) => {
    setWindowWidth(window.innerWidth);
    // console.log(window.innerWidth);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const mobileDrawerHandler = () => {
    setMobileDrawer(!mobileDrawer);
  };

  const connectDropdowmHandler = () => {
    setConnectDropdown(!connectDropdowm);
  };

  const injectedConnector = new InjectedConnector({
    supportedChainIds: [1, 3, 4, 5, 42],
  });

  let isMobile = useMediaQuery("(max-width: 650px)");

  // useEffect(() => {
  // console.log("isMobile =>>", isMobile);
  //   if (isMobile) {
  //     let accountLocal = window.localStorage.getItem("account");
  //     if (accountLocal !== "") {
  //       window.localStorage.setItem("account", "");
  //       window.location.reload();
  //     }
  //     if (account) {
  //       onMetaMaskConnect();
  //     }
  //   }
  // }, [account, isMobile, props?.address]);

  // useEffect(() => {
  // console.log("use effect running", account, props.address);
  //   if (account && props.address) {
  //     if (refresh.current == true && isMobile && account != props.address) {
  //       window.location.reload();
  //     }
  //     refresh.current = true;
  //   }
  // }, [account, isMobile, props.address]);

  const onMetaMaskConnect = async () => {
    setActivatingConnector("Injected");
    await activate(connectorsByName["Injected"]);
    props.checkWeb3React({ address: account, network: chainId });
    window.localStorage.setItem("account", account);
  };

  useEffect(() => {
    if (account && chainId) {
      let accountLocal = window.localStorage.getItem("account");
      // console.log("localAccount", accountLocal);
      if (accountLocal) {
        onMetaMaskConnect();
      }
    }
  }, [chainId, account]);

  const onMetaMaskConnectOther = () => {
    // console.log("On metaMaskCOnnectOther");
    let ethereum = window.ethereum;
    if (ethereum) {
      ethereum.enable();
      checkWeb3();
    } else {
      alert(`METAMASK NOT INSTALLED!!`);
    }
  };
  const numioWalletdownHandler = () => {
    setnumioWallet(!numioWallet);
  };

  const navItemClickHandler = (path) => {
    props.history.push(path);
    if (props.width === "xs" || props.width === "sm") {
      mobileDrawerHandler();
    }
  };

  return (
    <div className={classes.root}>
      {/* <Web3React/> */}
      <Backdrop
        className="backDrop"
        open={connectDropdowm}
        onClick={() => setConnectDropdown(false)}
      />

      <CssBaseline />
      <Dialog open={numioWallet}>
        <DialogContent>
          <DialogTitle id="alert-dialog-title">
            {"Numio wallet coming soon"}
          </DialogTitle>
          <DialogContentText id="alert-dialog-description">
            {"Please switch to meta mask for now"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => numioWalletdownHandler()}
            color="black"
            autoFocus
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <SwipeableDrawer
        anchor="left"
        open={mobileDrawer}
        onOpen={mobileDrawerHandler}
        onClose={mobileDrawerHandler}
      >
        <div style={{ marginTop: "32px", cursor: "pointer" }}>
          <img
            height="48px"
            onClick={() => {
              props.history.push("/");
            }}
            src={SidebarLogoOpen}
          />
          <Close
            onClick={mobileDrawerHandler}
            style={{
              position: "absolute",
              top: "44px",
              right: "30px",
              color: "white",
              cursor: "pointer",
            }}
          />
        </div>
        <List>
          {[
            [
              "Dashboard",
              DashboardLight,
              DashboardLightActive,
              "/",
              DashboardDark,
              DashboardDarkActive,
            ],
            [
              "Stake",
              StakeLight,
              StakeLightActive,
              "/stake",
              StakeDark,
              StakeDarkActive,
            ],
            [
              "Unstake",
              UnstakeLight,
              UnstakeLightActive,
              "/unstake",
              UnstakeDark,
              UnstakeDarkActive,
            ],
          ].map((text, index) => (
            <ListItem
              className={
                props.history.location.pathname === text[3]
                  ? themeMode === "light"
                    ? classes.navItemActiveLight
                    : classes.navItemActiveDark
                  : classes.navItem
              }
              onClick={() => navItemClickHandler(text[3])}
              button
              key={text[0]}
            >
              <ListItemIcon>
                <img
                  className={classes.navImage}
                  src={
                    props.history.location.pathname === text[3]
                      ? themeMode === "light"
                        ? text[2]
                        : text[5]
                      : themeMode === "light"
                      ? text[1]
                      : text[4]
                  }
                />
              </ListItemIcon>
              <ListItemText className={classes.navText} primary={text[0]} />
            </ListItem>
          ))}
        </List>
      </SwipeableDrawer>

      <Hidden smDown>
        <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            }),
          }}
          // style={{ backgroundColor: "red" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100vh",
            }}
          >
            <div>
              <div
                style={{
                  textAlign: "center",
                  paddingTop: "16px",
                  cursor: "pointer",
                }}
              >
                <img
                  className={classes.logoStyles}
                  height="48px"
                  src={
                    open === true
                      ? SidebarLogoOpen
                      : themeMode === "dark"
                      ? LogoDarkClose
                      : LogoLightClose
                  }
                  onClick={() => {
                    props.history.push("/");
                  }}
                />
              </div>

              <List style={{ padding: "1rem 0rem" }}>
                {[
                  [
                    "Dashboard",
                    DashboardLight,
                    DashboardLightActive,
                    "/",
                    DashboardDark,
                    DashboardDarkActive,
                  ],
                  [
                    "Stake",
                    StakeLight,
                    StakeLightActive,
                    "/stake",
                    StakeDark,
                    StakeDarkActive,
                  ],
                  [
                    "Unstake",
                    UnstakeLight,
                    UnstakeLightActive,
                    "/unstake",
                    UnstakeDark,
                    UnstakeDarkActive,
                  ],
                ].map((text, index) => (
                  <ListItem
                    className={
                      props.history.location.pathname === text[3]
                        ? themeMode === "light"
                          ? classes.navItemActiveLight
                          : classes.navItemActiveDark
                        : classes.navItem
                    }
                    onClick={() => navItemClickHandler(text[3])}
                    button
                    key={text[0]}
                  >
                    <ListItemIcon>
                      <img
                        className={classes.navImage}
                        src={
                          props.history.location.pathname === text[3]
                            ? themeMode === "light"
                              ? text[2]
                              : text[5]
                            : themeMode === "light"
                            ? text[1]
                            : text[4]
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.navText }}
                      primary={text[0]}
                    />
                  </ListItem>
                ))}
              </List>
            </div>
            {/* <h1>Heyyyyyyyyy</h1> */}
            {/* <h2>{`${open}`}</h2> */}
            <VersionSwitch isSidebarOpen={open} />
          </div>
        </Drawer>
      </Hidden>

      <main className={classes.contentBack}>
        <Grid container className={classes.content}>
          <Grid container item justify="space-around" xs={12}>
            <Grid xs={12} md={11} justify="space-between" container item>
              <Grid style={{ display: "flex", alignItems: "center" }} item>
                <IconButton
                  className={classes.hoverTackle}
                  style={{ marginLeft: "1px" }}
                  onClick={() => {
                    props.sideDrawerClicked();
                    (props.width === "xs" || props.width === "sm"
                      ? mobileDrawerHandler
                      : open === false
                      ? handleDrawerOpen
                      : handleDrawerClose)();
                  }}
                  edge="start"
                >
                  {open === true ? (
                    <img
                      className={classes.menuIconOpen}
                      height="24px"
                      src={MenuIconOpen}
                    />
                  ) : (
                    <img
                      className={classes.menuIconClose}
                      height="40px"
                      src={MenuIconClose}
                    />
                  )}
                </IconButton>
                <Button
                  onClick={() => {
                    props.history.push("/stake");
                  }}
                  style={{
                    background: "#220ceb",
                    color: "#FFFFFF",
                    padding: "6px 22px",
                    fontWeight: "bold",
                    textTransform: "none",
                  }}
                >
                  Stake Now
                </Button>
              </Grid>
              {/* <button onClick={getContractInfo} >CONTEXT</button> */}

              <Grid
                style={
                  props.width === "xs" || props.width === "sm"
                    ? {
                        display: "flex",
                        paddingRight: "12px",
                        alignItems: "center",
                      }
                    : { display: "flex", alignItems: "center" }
                }
                item
              >
                <p
                  className={classes.walletText}
                  style={
                    props.width !== "xs"
                      ? { marginRight: "8px" }
                      : { display: "none" }
                  }
                >
                  {props.address ? "Wallet Connected" : "Connect Wallet"}
                </p>
                {props.address ? (
                  <div>
                    <div
                      // onClick={connectDropdowmHandler}
                      className={classes.connectButton}
                      style={{ padding: "10px 20px", position: "relative" }}
                    >
                      <span style={{ color: "white" }}>{`${props.address.slice(
                        0,
                        10
                      )}...${props.address.slice(
                        props.address.length - 5
                      )}`}</span>
                      <span
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 2,
                          backgroundColor: "#68e285",
                          height: 10,
                          width: 10,
                          borderRadius: "50%",
                          border: "2px solid white",
                        }}
                      ></span>
                    </div>
                    {connectDropdowm ? (
                      <div className="connectDropdown">
                        <Button
                          onClick={() => onMetaMaskConnectOther()}
                          className="connectDropwdownButton"
                        >
                          Connect to another wallet
                        </Button>
                        <Button
                          onClick={() => numioWalletdownHandler()}
                          className="connectDropwdownButton"
                        >
                          Connect to Numio wallet
                        </Button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : connect ? (
                  <div className={classes.connectButton}>
                    <img
                      src={MetamaskIcon}
                      alt="wallet button icon"
                      onClick={() => onMetaMaskConnect()}
                      className={classes.connectButtonIcon}
                      style={{
                        borderRight: "1px solid white",
                        paddingRight: "6px",
                      }}
                    />

                    {/* <img
                      src={NumioIcon}
                      alt="wallet button icon"
                      onClick={() => numioWalletdownHandler()}
                      className={classes.connectButtonIcon}
                    /> */}
                  </div>
                ) : (
                  <div
                    className={classes.plusButton}
                    style={{
                      display: "flex",
                      margin: "auto",
                      marginRight: "1px",
                    }}
                    onClick={() => {
                      activate(injectedConnector);
                      setConnect(true);
                    }}
                  >
                    <img
                      height="32px"
                      className={classes.plusImage}
                      src={ConnectwalletIcon}
                      alt="connect + icon"
                    />
                  </div>
                )}
                <Tooltip title="User Guide">
                  <Link
                    href="https://medium.com/phoenixdao/a-complete-guide-for-phnx-spot-staking-dapp-we-are-live-b3b9bb8d466c?sk=8b999d013a33d962941cb1df486377c8"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <Help className={classes.help} />
                  </Link>
                </Tooltip>
              </Grid>
            </Grid>

            <Grid xs={12} md={11} justify="space-between" container item>
              <Grid
                xs={12}
                sm={12}
                md={open === true && window.innerWidth < 1140 ? 12 : 9}
                container
                item
              >
                <Grid xs={12} container item>
                  <UserPortfolio />
                </Grid>
                <Grid
                  xs={12}
                  style={{
                    margin: "12px",
                    marginTop: "0px",
                    minHeight: "400px",
                  }}
                  contaienr
                  item
                >
                  {props.children}
                </Grid>
              </Grid>
              {open === true && window.innerWidth < 1140 ? (
                ""
              ) : (
                <Hidden smDown>
                  <Grid xs={3} style={{ height: "100%" }} container item>
                    <BuyPHNX />
                  </Grid>
                </Hidden>
              )}
            </Grid>

            <Grid
              xs={12}
              md={11}
              container
              item
              style={{ marginTop: "32px" }}
              justify="space-between"
            >
              <Grid
                xs={12}
                style={
                  props.width === "xs" || props.width === "sm"
                    ? {
                        textAlign: "Center",
                        margin: "12px 0px",
                      }
                    : { textAlign: "right" }
                }
                item
              >
                <span
                  className={classes.mySwitch}
                  style={
                    themeMode === "dark"
                      ? { border: "1px solid #5A5A5A" }
                      : { border: "1px solid #E0E0E0" }
                  }
                  onClick={toggleThemeMode}
                >
                  <img
                    style={{
                      height: "18px",
                      marginRight: "6px",
                      display: "inline-block",
                      verticalAlign: "middle",
                    }}
                    src={themeMode === "light" ? SunLight : SunDark}
                  />
                  <img
                    style={{
                      height: "18px",
                      display: "inline-block",
                      verticalAlign: "middle",
                    }}
                    src={themeMode === "light" ? MoonLight : MoonDark}
                  />
                </span>
              </Grid>
              <Grid
                xs={12}
                md={6}
                style={
                  props.width === "xs" || props.width === "sm"
                    ? { paddingLeft: "12px", textAlign: "Center" }
                    : { textAlign: "left", paddingLeft: "10px" }
                }
                item
              >
                <Link
                  href="https://twitter.com/phnxdao"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    className={classes.socialIcons}
                    height={24}
                    style={{ margin: 4 }}
                    src={themeMode === "dark" ? TwitterDark : TwitterLight}
                    alt="social icons"
                  />
                </Link>
                <Link
                  href="https://t.me/PHNXDAO"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    className={classes.socialIcons}
                    height={24}
                    style={{ margin: 4 }}
                    src={themeMode === "dark" ? TelegramDark : TelegramLight}
                    alt="social icons"
                  />
                </Link>
                <Link
                  href="https://github.com/PhoenixDAO"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    className={classes.socialIcons}
                    height={24}
                    style={{ margin: 4 }}
                    src={themeMode === "dark" ? GithubDark : GithubLight}
                    alt="social icons"
                  />
                </Link>
                <Link
                  href="https://www.linkedin.com/company/phoenixdao-phnx/?viewAsMember=true"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    className={classes.socialIcons}
                    height={24}
                    style={{ margin: 4 }}
                    src={themeMode === "dark" ? LinkedinDark : LinkedinLight}
                    alt="social icons"
                  />
                </Link>
              </Grid>
              <Grid xs={12} md={6} item>
                <p
                  className={classes.myPara}
                  style={
                    props.width === "xs" || props.width === "sm"
                      ? {
                          paddingRight: "12px",
                          textAlign: "Center",
                          color: "#898989",
                        }
                      : { textAlign: "right", color: "#898989" }
                  }
                >
                  PhoenixDAO Staking dApp | Copyright{" "}
                  <Link
                    href="https://phoenixdao.io/"
                    rel="noreferrer"
                    target="_blank"
                    style={{ color: "#898989" }}
                  >
                    @PhoenixDAO
                  </Link>
                </p>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    address: state.layoutReducer.address,
    network: state.layoutReducer.network,
    themeMode: state.layoutReducer.themeMode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    checkWeb3: () => dispatch(checkWeb3()),

    checkWeb3React: (load) => dispatch(checkWeb3React(load)),
    web3React: (chainId, account) => dispatch(web3React(chainId, account)),
    themeModeChanged: (themeMode) => dispatch(themeModeChanged(themeMode)),
    sideDrawerClicked: () => dispatch(sideDrawerClicked()),
  };
};

export default withWidth()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(MiniDrawer))
);
